<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="margin-top: 60px; padding: 15px 0px 0px 0px;"
         id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/about-2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first gdlr-core-hide-in-mobile"
               id="gdlr-core-column-38316">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 50px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px; margin-right: 10px;">
                      <img src="static/upload/iStock-956377212.jpg" alt="" width="900" height="623" title="img 001">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-right-align gdlr-core-style-vertical"
                    style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; height: 90px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-7419">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 110px; padding: 70px 0px 0px 50px; height: 524.68px;"
                 data-sync-height="height-img">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                          <span class="gdlr-core-title-item-left-dot"
                                style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          Values
                          </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        海外资产配置的价值
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                                                                <span class="gdlr-core-icon-list-image gdlr-core-left"
                                                                      style="max-width: 35px; margin-top: -2px;">
                                                                    <img src="static/upload/logo01.png" alt=""
                                                                         width="120"
                                                                         height="120" title="logo01">
                                                                </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                                                                    <span class="gdlr-core-icon-list-content"
                                                                          style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                                                                        分散风险
                                                                    </span>
                          <ul>
                            <li>风险分散和对冲是现阶段高净值人群考虑海外投资的最主要原动力，风险主要包括人民币汇率风险和国内通胀风险。</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                                                                <span class="gdlr-core-icon-list-image gdlr-core-left"
                                                                      style="max-width: 35px; margin-top: -2px;">
                                                                    <img src="static/upload/logo02.png" alt=""
                                                                         width="120"
                                                                         height="120" title="logo02">
                                                                </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                              <span class="gdlr-core-icon-list-content"
                                    style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">增强收益</span>
                          <ul>
                            <li>从收益的角度来看，海外资产配置可以在全球范围内寻找风险可控但收益更佳的资产类别，特别是某段时期内国内没有很好的投资产品的时候更显现出海外资产配置的优势。</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                                                                <span class="gdlr-core-icon-list-image gdlr-core-left"
                                                                      style="max-width: 35px; margin-top: -2px;">
                                                                    <img src="static/upload/logo03.png" alt=""
                                                                         width="120"
                                                                         height="120" title="logo03">
                                                                </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                              <span class="gdlr-core-icon-list-content"
                                    style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">资金使用需求</span>
                          <ul>
                            <li>除了规避汇率风险和通胀风险，增强收益以外，其他海外配置的原因还包括子女教育，移民，养老等。</li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="margin: 0px 0px 0px 0px; padding: 100px 0px 90px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f7f7f7;"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">

          <div class="gdlr-core-pbf-column gdlr-core-column-15 gdlr-core-column-first" id="gdlr-core-column-47742">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-item-pdlr" style="padding-bottom: 28px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px; max-width: 73px;">
                      <img src="static/upload/icon01.png" alt="" width="155" height="155" title="icon01">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 25px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #222222;">
                        <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 11px;"></span>
                        固收
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 15px;">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #6c6c6c;">
                      <ul>
                        <li>流动性管理</li>
                        <li>二级债券</li>
                        <li>
                          类固收
                          <ul>
                            <li>消费信贷类</li>
                            <li>结构化产（ABS）</li>
                            <li>保单贴现</li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 2px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-10409">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-item-pdlr" style="padding-bottom: 28px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px; max-width: 73px;">
                      <img src="static/upload/icon02.png" alt="" width="155" height="155" title="icon02">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 25px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #222222;">
                        <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 11px;"></span>
                        权益
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 15px;">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #6c6c6c;">
                      <ul>
                        <li>二级股票</li>
                        <li>IPO配售</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 2px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-item-pdlr" style="padding-bottom: 28px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px; max-width: 73px;">
                      <img src="static/upload/icon03.png" alt="" width="155" height="155" title="icon03">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 25px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #222222;">
                        <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 11px;"></span>
                        地产
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 15px;">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #6c6c6c;">
                      <ul>
                        <li>房地产信托(REITS)</li>
                        <li>地产权益基金</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 2px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-item-pdlr" style="padding-bottom: 28px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px; max-width: 73px;">
                      <img src="static/upload/icon04.png" alt="" width="155" height="155" title="icon03">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 25px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #222222;">
                        <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 11px;"></span>
                        另类
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 15px;">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #6c6c6c;">
                      <ul>
                        <li>私募股权</li>
                        <li>对冲基金</li>
                        <li>大宗商品</li>
                        <li>不动产</li>
                        <li>衍生品</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 2px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ServiceContent3'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceContent3.vue